export default "__VITE_ASSET__292774c9__"